import Home from "@mui/icons-material/Home";
import Star from "@mui/icons-material/Star";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useIsActive } from "./sidebar/hooks/use-is-active";
import { Item } from "./sidebar/item";
import { Section } from "./sidebar/section";
import { Sidebar } from "./sidebar/sidebar";

import type { FC } from "react";

export const CeAdminSidebar: FC = () => {
  const isActive = useIsActive();

  return (
    <Sidebar footer={null}>
      <Stack sx={{ height: "100%" }}>
        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: "center", justifyContent: "space-between", p: 3 }}
        >
          <Typography variant="h6">ChangeEngine Admin</Typography>
          <Button data-analytics-id="ce-admin-logout" href="/logout" variant="outlined">
            Logout
          </Button>
        </Stack>
        <Stack
          component="nav"
          spacing={2}
          sx={{
            flexGrow: 1,
            px: 2,
          }}
        >
          <CreateAccountButton />
          <Section>
            <>
              <Item
                title="Accounts"
                icon={<Home />}
                onClick={{ type: "href", value: "/ce_admin" }}
                active={isActive("/ce_admin")}
              />
              <Item
                title="Additional Services"
                icon={<Star />}
                onClick={{ type: "href", value: "/ce_admin/additional_services" }}
                active={isActive("/ce_admin/additional_services")}
              />
            </>
          </Section>
        </Stack>
      </Stack>
    </Sidebar>
  );
};

const CreateAccountButton: FC = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <Button
      data-analytics-id="ce-admin-create-account"
      size="large"
      variant="contained"
      href="/ce_admin/create_account"
      fullWidth
      sx={{ mx: 1 }}
    >
      Create Account
    </Button>
  </Box>
);
